import type { TemplateField } from "shared/api/templateService"

const normalizeKeyPart = (value?: string | null, fallback = "field"): string =>
  (value ?? fallback)
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9_-]+/g, "-")
    .replace(/^-+|-+$/g, "") || fallback

export const buildTemplateFieldValidationKey = (field?: Pick<TemplateField, "fieldId" | "code" | "label"> | null) => {
  if (!field) {
    return null
  }
  const base = field.fieldId ?? field.code ?? field.label ?? "field"
  return `field:${normalizeKeyPart(base)}`
}

export const buildSubactivityValidationKey = (subactivityId: string, fieldId: string) =>
  `subactivity:${normalizeKeyPart(subactivityId, "subactivity")}_${normalizeKeyPart(fieldId)}`

export const buildRequiredDocumentValidationKey = (documentId: string) =>
  `document:${normalizeKeyPart(documentId, "document")}`

export const buildRiskValidationKey = (riskKey: string) =>
  `risk:${normalizeKeyPart(riskKey, "risk")}`
